/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatNegotiation } from './chatNegotiation';


export interface Negotiation { 
    id?: number;
    initiatorCpfCnpj?: string;
    recipientCpfCnpj?: string;
    status?: Negotiation.StatusEnum;
    createdAt?: string;
    updatedAt?: string;
    initialMessage?: string;
    referenceId?: number;
    referenceType?: string;
    chatsNegotiations?: Array<ChatNegotiation>;
    serviceDemandNegotiation?: boolean;
    negotiatedItemId?: number;
    resourceOfferingNegotiation?: boolean;
    resourceDemandNegotiation?: boolean;
    serviceOfferingNegotiation?: boolean;
    negotiationType?: string;
}
export namespace Negotiation {
    export type StatusEnum = 'PENDING' | 'ACCEPTED' | 'REJECTED' | 'CANCELLED' | 'IN_PROGRESS' | 'COMPLETED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Accepted: 'ACCEPTED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum
    };
}


